<template>

    <input class="input-normal" type="text" ref="input"
           :name="name"
           :placeholder="placeholder"
           :class="{ error: error }"
           @blur="onInputBlur"
           @keydown.enter="$event.target.blur()" />

</template>

<script>

import di from 'di'

import Component from 'vue-class-component'
import Vue from 'global-vue'

import moment from 'moment'
import Cleave from 'cleave.js'

@Component({

    name: 'cms-form-date-picker',
    props: {
        value: String,
        name: String,
        placeholder: String,
        error: String,

        time: [Boolean, String],
        valueFormat: {
            type: String,
            default: "Y-MM-DD"
        },
        options: {
            type: Object,
            default: () => ({})
        }
    }
})
export default class extends Vue
{
    mounted(){

        this.cleave = new Cleave(this.$refs.input, {
            date: true,
            delimiter: '-',
            datePattern: ['d', 'm', 'Y']
        });

        this.$watch('value', newValue => this.updateFromValue(newValue));
        this.updateFromValue(this.value);
    }

    updateValue(value){

        this.$emit('input', value);
    }

    updateFromValue(value){

        let rawValue = null;

        if(value){

            const date = moment(value, 'YYYY-MM-DD');
            if(date.isValid()){
                rawValue = date.format('DDMMYYYY');
            }
        }

        this.cleave.setRawValue(rawValue);
    }

    onInputBlur(){

        const value = this.cleave.getRawValue();
        if(!value){
            return;
        }

        const date = moment(value, "DDMMYYYY");
        if(!date.isValid()){
            return;
        }

        this.updateValue(date.format('YYYY-MM-DD'));

        this.$emit('blur');
    }
}

</script>